import { apiClient } from './apiClient';

export const operatorQueueCountsQueryKey = (tenantId: string) =>
  ['google-ads-operator-queue-counts', tenantId] as const;

export type OperatorQueueCounts = {
  tenant_id: string;
  management_easy_yes: number;
  search_terms_easy: number | null;
};

export async function getOperatorQueueCounts(
  tenantId: string,
): Promise<OperatorQueueCounts> {
  const { data } = await apiClient.get<OperatorQueueCounts>(
    '/google-ads/operator-queue/counts',
    { params: { tenant_id: tenantId } },
  );
  return data;
}
